import * as React from "react";
const SvgFiRrHumidity = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-humidity_svg__a)">
      <path
        fill="#062147"
        d="M10 17a1 1 0 0 1-.831-1.555l4-6a1 1 0 1 1 1.664 1.11l-4 6A1 1 0 0 1 10 17m9.779 3.778c6.858-7.336 1.519-14.521-4.565-19.6a4.95 4.95 0 0 0-6.426 0C2.706 6.23-2.63 13.49 4.222 20.778a11 11 0 0 0 15.557 0M13.919 2.7c4.78 4.077 10.51 10.266 4.445 16.664a9.043 9.043 0 0 1-12.728 0c-6.071-6.4-.325-12.6 4.445-16.662a2.96 2.96 0 0 1 3.838 0zM7.999 10a1 1 0 1 0 2 0 1 1 0 0 0-2 0m6 6A1 1 0 1 0 16 16a1 1 0 0 0-2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-humidity_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHumidity;
